import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { FavoriteFolderResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function fetchAllFavoriteFolders(): Promise<FavoriteFolderResponse> {
  const response = await axiosInstance.get<FavoriteFolderResponse>(api.getAllFavoriteFolders);
  return response.data;
}

const useGetAllFavoriteFoldersQuery = (enabled = true) =>
  useQuery<FavoriteFolderResponse>({
    queryKey: queryKeys.favorite.allFolders(),
    queryFn: fetchAllFavoriteFolders,
    enabled,
  });

export default useGetAllFavoriteFoldersQuery;
